import { forEach, get } from 'lodash-es'
import store from '../../../vue/store'

export default {
  props: {
    giftData: {
      type: Object,
      required: false
    }
  },
  computed: {
    giftSelection () {
      return this.giftData ? get(this.$store.state.selectedGifts, [this.giftData.id, this.productData.productId]) || false : ''
    }
  },
  methods: {
    updateGiftSelection (changeEvent) {
      const dispatchAction = (this.giftSelection) ? 'removeGiftFromSelection' : 'addGiftToSelection'
      const gift = {
        giftId: this.giftData.id,
        productId: this.productData.productId
      }

      var existingEntries = JSON.parse(localStorage.getItem('giftSelection'))
      if (existingEntries == null) existingEntries = []

      if (dispatchAction === 'removeGiftFromSelection') {
        existingEntries.pop(gift)
      } else {
        existingEntries.push(gift)
      }

      localStorage.setItem('giftSelection', JSON.stringify(existingEntries))
      this.$store.dispatch(dispatchAction, gift)
    },
    getGiftSelectionFromLocalStorage () {
      const gifts = JSON.parse(localStorage.getItem('giftSelection'))
      const giftProductChoicesValues = Object.values(this.getGiftProductChoices)
      forEach(gifts, (value) => {
        const productId = value.productId
        if (giftProductChoicesValues.includes(String(productId))) {
          store.dispatch('addGiftToSelection', value)
        }
      })
    }
  }
}
